import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryClassModel } from 'src/app/models/inventory/inventory-class.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InventoryClassTableModel } from 'src/app/models/tables/inventory/inventory-class-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryClassService {

  constructor(private _httpClient: HttpClient) { }

  getAllInventoryClass(): Observable<Array<InventoryClassModel>> {
    return this._httpClient.get<Array<InventoryClassModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.GetAllInventoryClass}`);
  }

  getAllInventoryClassForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.GetAllInventoryClassForSelectAsync}`,);
  }

  getColumnsForConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.GetColumnsForConsultation}`);
  }

  getInventoryClassesForConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<InventoryClassTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<InventoryClassTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.GetInventoryClassesForConsultation}`,
      filters, { params: params }
    );
  }

  createInventoryClass(inventoryClassContractModel: InventoryClassModel): Observable<InventoryClassModel> {
    return this._httpClient.post<InventoryClassModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.CreateInventoryClass}`,
      inventoryClassContractModel);
  }

  getInventoryClassById(inventoryClassId: number | null): Observable<InventoryClassModel> {
    return this._httpClient.get<InventoryClassModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.GetInventoryClassById}/${inventoryClassId}`);
  }

  updateInventoryClass(inventoryClassContractModel: InventoryClassModel): Observable<InventoryClassModel> {
    return this._httpClient.put<InventoryClassModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.UpdateInventoryClass}`,
      inventoryClassContractModel)
  }

  deleteInventoryClass(inventoryClassId: number): Observable<InventoryClassModel> {
    return this._httpClient.delete<InventoryClassModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.DeleteInventoryClass}/${inventoryClassId}`);
  }

  getInventoryClassByCode(code: number): Observable<InventoryClassModel> {
    return this._httpClient.get<InventoryClassModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryClass.GetInventoryClassByCode}/${code}`)
  }

}
